// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3_33a","container":"styles_container__2Ffmo","title":"styles_title__2TEWe","wrapper":"styles_wrapper__3zizz","answer":"styles_answer__HvtcB"};